var map = {
	"./BOT.jpg": 8386,
	"./TOP.jpg": 9354,
	"./content.txt": 8781,
	"./global.css": 8645,
	"./image1.jpg": 2390,
	"./image10.png": 73,
	"./image11.jpg": 7839,
	"./image12.jpg": 3089,
	"./image13.jpg": 5011,
	"./image14.jpg": 726,
	"./image15.jpg": 7174,
	"./image16.png": 6,
	"./image17.png": 1999,
	"./image18.png": 6053,
	"./image2.png": 9922,
	"./image3.jpg": 5680,
	"./image4.jpg": 6692,
	"./image5.jpg": 5904,
	"./image6.jpg": 3262,
	"./image7.jpg": 7421,
	"./image8.jpg": 247,
	"./image9.jpg": 5430,
	"./logo.png": 6949,
	"./voice1.mp3": 8061,
	"./voice2.mp3": 900,
	"./voice3.mp3": 5451,
	"./voice4.m4a": 539,
	"./voice5.m4a": 2258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;